import axios from 'axios';
import { BASE_URL } from '../apiConfig';
import { getTenantHeaders } from '../config/tenant';
import { StudentVideosProgressResponse, StudentQuizzesProgressResponse } from '../types/parentProgress';

export const getStudentVideosProgressByParent = async (
  parentPhone: string,
  studentPhone: string
): Promise<StudentVideosProgressResponse> => {
  try {
    const response = await axios.get<StudentVideosProgressResponse>(
      `${BASE_URL}api/Student/GetStudentVideosProgressByParent/${parentPhone}`,
      {
        params: {
          studentPhone: studentPhone
        },
        headers: {
          ...getTenantHeaders()
        }
      }
    );

    return response.data;
  } catch (error: any) {
    console.error('Error fetching student videos progress:', error);
    throw new Error(
      error.response?.data?.message || 
      'فشل في جلب بيانات تقدم الطالب. يرجى التحقق من أرقام الهواتف والمحاولة مرة أخرى.'
    );
  }
};

export const getStudentQuizzesProgressByParent = async (
  parentPhone: string,
  studentPhone: string
): Promise<StudentQuizzesProgressResponse> => {
  try {
    const response = await axios.get<StudentQuizzesProgressResponse>(
      `${BASE_URL}api/Student/GetStudentQuizzesProgressByParent/${parentPhone}`,
      {
        params: {
          studentPhone: studentPhone
        },
        headers: {
          ...getTenantHeaders()
        }
      }
    );

    return response.data;
  } catch (error: any) {
    console.error('Error fetching student quizzes progress:', error);
    throw new Error(
      error.response?.data?.message || 
      'فشل في جلب بيانات تقدم الاختبارات. يرجى التحقق من أرقام الهواتف والمحاولة مرة أخرى.'
    );
  }
};
